"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));

var cache = require('./common/browser/cache');

module.exports = {
  loadLang: require('./loadLang')((0, _extends2.default)({
    gunzip: require('./common/browser/gunzip')
  }, cache)),
  readImage: require('./readImage'),
  cache: cache
};